import { eventBus } from "./event-bus"

const SIDEBAR_STATE = {
    COLLAPSED: 'false',
    EXPANDED: 'true'
}

const EVENT_NAME = 'toggle-sidebar'

const determineInitialState = () => {
    return localStorage.getItem('sidebar:state') || SIDEBAR_STATE.COLLAPSED
}

const updateMainContainerLayout = () => {
    const container = document.querySelector('.mfe-container')
    const isExpanded = determineInitialState() === SIDEBAR_STATE.EXPANDED
    if (isExpanded) {
        container?.classList.add('toggle')
        return
    }

    container?.classList.remove('toggle')
}

const emit = () => eventBus.emit(EVENT_NAME, null)
const subscribe = (callback: () => void) => eventBus.on(EVENT_NAME, callback)
const unsubscribe = (callback: () => void) => eventBus.off(EVENT_NAME, callback)

export {
    SIDEBAR_STATE,
    determineInitialState,
    updateMainContainerLayout,
    emit,
    subscribe,
    unsubscribe
}